import { NgModule } from '@angular/core';
import { RouterModule } from '@angular/router';
import { localeResolver } from '@core/resolvers/locale.resolver';
import { myApplicationsResolver } from '@core/resolvers/my-applications.resolver';
import { employeeSSOFieldsResolver } from '@features/employee-sso-fields/resolvers/employee-sso-fields.resolver';
import { applicationResolver } from './application.resolver';
import { ApplyPageComponent } from './apply-page/apply-page.component';
import { ApplyModule } from './apply.module';
import { PublicProgramPageComponent } from './public-program-page/public-program-page.component';
const applyPageResolvers = {
  locale: localeResolver,
  ssoFields: employeeSSOFieldsResolver,
  application: applicationResolver
};

@NgModule({
  imports: [
    ApplyModule,
    RouterModule.forChild([{
      path: ':programId',
      resolve: {
        myApplications: myApplicationsResolver
      },
      children: [{
        path: '',
        component: PublicProgramPageComponent
      }, {
        path: 'apply',
        component: ApplyPageComponent,
        data: {
          namespace: ['APPLY', 'addOrg', 'search'],
          pageName: 'Apply Page'
        },
        resolve: applyPageResolvers
      }, {
        path: 'routing',
        component: ApplyPageComponent,
        data: {
          namespace: ['APPLY', 'addOrg', 'search'],
          pageName: 'Route Page',
          isRouting: true
        },
        resolve: {
          locale: localeResolver,
          ssoFields: employeeSSOFieldsResolver
        }
      }]
    }])
  ]
})
export class ProgramRoutingModule { }
